import React from 'react';
import { EditorStringModel } from '../Types/EditorString';
import EditorString from '../Components/EditorString/EditorString';
import clsx from 'clsx';

interface RichTextBlockProps {
  rowLayout: 'slim' | 'container' | 'fullwidth' | 'fullwidth-nopadding';
  columns: RichTextColumn[];
  slimContainerMaxWidth: number;
  verticalAlignment?: 'flex-start' | 'center' | 'flex-end';
  reverseColumnOrderForMobile: boolean;
}

interface RichTextColumn {
  columnCount: number;
  columnCountMobile?: number;
  text: EditorStringModel;
  textMobile?: EditorStringModel;
}

const RichTextBlock = ({
  rowLayout,
  columns,
  slimContainerMaxWidth,
  verticalAlignment,
  reverseColumnOrderForMobile,
}: RichTextBlockProps) => {
  return (
    <div
      className={clsx(
        'grid grid-cols-12',
        rowLayout != 'fullwidth-nopadding' && 'container',
        rowLayout == 'fullwidth' && 'container container--fullwidth',
        rowLayout == 'slim' && 'mx-auto'
      )}
      style={{
        alignItems: verticalAlignment,
        maxWidth: rowLayout == 'slim' ? slimContainerMaxWidth : undefined,
      }}
    >
      {columns.map((col, idx) => (
        <div
          key={`${col.columnCount}-${idx}`}
          className={clsx(
            'lg:!order-none',
            `col-span-${col.columnCountMobile ?? col.columnCount}`,
            col.columnCountMobile && `lg:col-span-${col.columnCount}`
          )}
          style={{
            order: reverseColumnOrderForMobile
              ? columns.length - idx
              : undefined,
          }}
        >
          {/* Desktop */}
          <div
            className={clsx(!!col.textMobile?.value && 'lg:block hidden')}
          >
            <EditorString {...col.text} />
          </div>
          {/* Mobile */}
          {!!col.textMobile?.value && (
            <div className="lg:hidden">
              <EditorString {...col.textMobile} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default RichTextBlock;
